import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { useApi, errMsg } from "@/lib/api";
import { useMe, can } from "@/context/MeContext";

export const ExtraRecipients = ({ value, onSaved }) => {
  const api = useApi();
  const admin = can(useMe(), "accounts");
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { setText((value || []).join("\n")); }, [value]);
  const save = async () => {
    setBusy(true);
    try {
      const r = await api("put", "/ai/epi-report/recipients", { emails: text.split(/[\s,;]+/).filter(Boolean) });
      toast.success(`${r.extra_recipients.length} destinataire(s) supplémentaire(s) enregistré(s)`);
      onSaved();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  if (!admin) {
    return <p className="text-stone-600" data-testid="ai-weekly-extra-readonly">Autres destinataires : {(value || []).join(", ") || "aucun"}</p>;
  }
  return (
    <div className="space-y-2" data-testid="ai-weekly-extra">
      <p className="font-medium text-stone-900">Autres destinataires (ex. direction de la santé)</p>
      <Textarea rows={3} value={text} onChange={(e) => setText(e.target.value)} placeholder={"une adresse par ligne\ncontact@dsp-wilaya.dz"} data-testid="ai-weekly-extra-input" />
      <Button variant="outline" size="sm" disabled={busy} onClick={save} data-testid="ai-weekly-extra-save">Enregistrer les destinataires</Button>
    </div>
  );
};
